import SettingsEditMamorio from './SettingsEditMamorio'

export default SettingsEditMamorio
